module.exports = __webpack_public_path__ + "static/worldwidegas-d1144f5eb3e84eb34d542b08c48f23e6.pdf";